export const prettyPrintEuros = (v: number) => {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "EUR",
  }).format(v);
};
